import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-profile-completion',
  templateUrl: './profile-completion.component.html',
  styleUrls: ['./profile-completion.component.css'],
})
export class ProfileCompletionComponent {
  @Input() percentage: number = 0;

  get circumference(): number {
    return 2 * Math.PI * 20;
  }
  get offset(): number {
    return this.circumference - (this.percentage / 100) * this.circumference;
  }
}
